export * from './baProfilePicture.pipe';



// WEBPACK FOOTER //
// ./src/app/theme/pipes/baProfilePicture/index.ts